module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"create-sku-map":"Create SKU map","sku-map-created":"SKU map created","failed-create-sku-map":"Failed to create SKU map"}}')
  delete Component.options._Ctor
}
